import { updateUserService } from '../api/services';
import { PATCH_USER_SERVICES_SUCCESS } from '../constants/services';

export const patchUserServices = (data) => async (dispatch) => {
  await updateUserService(data);
  dispatch({
    type: PATCH_USER_SERVICES_SUCCESS,
    payload: data
  });
};
